import { appendIf } from '@btime/helpers'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React, { useCallback } from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { useFormState } from '../../../../packages/kiti/components/form/form/FormHandler'
import AssetSelect from '../../../../containers/assets/select/AssetSelect'
import BulkForm from '../../../../packages/kiti/components/form/form/BulkForm'
import ChecklistSelect from '../../../../containers/checklists/select/ChecklistSelect'
import DateInput from '../../../../components/form/date/DateInput'
import Icon from '../../../../packages/kiti/components/shapes/Icon'
import Line from '../../../../packages/kiti/components/helpers/Line'
import Modal from '../../../../components/structure/Modal'
import PlaceSelect from '../../../../containers/places/select/PlaceSelect'
import Scroll from '../../../../packages/kiti/components/helpers/Scroll'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import SubmitBar from '../../../../packages/kiti/components/form/SubmitBar'
import Textarea from '../../../../packages/kiti/components/form/Textarea'
import UsersOrGroupsSelect from '../../../../containers/users/select/UsersOrGroupsSelect'
import FlexGrid from '../../../../components/structure/FlexGrid'
import Text, { Title } from '../../../../packages/kiti/components/presentation/Text'
import Button from '../../../../packages/kiti/components/actions/Button'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import Circle from '../../../../packages/kiti/components/shapes/Circle'
import { validate as validateForm, validatePayload } from '../_requests/validate'

const BulkServiceOrdersInputButton = ({ onClick }) => {
  const { t } = useTranslation('routines')
  const { form } = useFormState()
  return (
    <FormItem field={'payload'}>
      <FlexGrid gutter={0.2} justify="left">
        <Button transparent onClick={onClick} badge={form.payload?.length}>
          <Grid gap={0.5}>
            <Text size={'small'} align="center" color={'primary'} bold>
              {t('configureActivities')}
            </Text>
            {!!form.payload?.length && (
              <Circle size={'20px'}>
                <Text color={'white'} size={'xsmall'}>
                  {form.payload?.length}
                </Text>
              </Circle>
            )}
          </Grid>
        </Button>
      </FlexGrid>
    </FormItem>
  )
}

const ServiceOrdersSection = () => {
  const { t } = useTranslation(['routines', 'triggers'])
  const { form, setErrors } = useFormState()
  const canUseName = useSessionPermission('editServiceOrdersName')
  const [open, setOpen] = React.useState()

  const validate = useCallback(() => {
    const errors = validatePayload(form, true)
    if (!errors.length) {
      setOpen(false)
    }
    validateForm(form, setErrors)
  }, [form, setErrors])

  return (
    <>
      <Separator weight={2} />
      <Title size="small" bold color="dark3">
        {t('routines:activitiesRequired')}
      </Title>
      <Separator weight={2} />

      <BulkServiceOrdersInputButton field={'payload'} onClick={() => setOpen(!open)} />
      <Separator weight={4} />

      <>
        <Modal open={open} onClose={() => setOpen(false)} fullScreen noPadding>
          <Separator paddingV={1.7} paddingH={2}>
            <Grid justify="space-between">
              <Col flex={1}>
                <Title size="h5" noMargin>
                  {t('triggers:bulkRegistration')}
                </Title>
              </Col>
              <Col>
                <Icon name="BsX" onClick={() => setOpen(false)} size={1.5} color="dark1" />
              </Col>
            </Grid>
          </Separator>
          <Line />

          <Scroll height="69vh" scroll scrollX direction="row">
            <Separator weight={8} flex={1}>
              <BulkForm
                path={['payload']}
                fields={[
                  ...appendIf(canUseName, { label: t('triggers:fields.name'), name: 'name' }),
                  {
                    label: t('triggers:fields.checklist'),
                    name: 'checklist',
                    Input: ChecklistSelect
                  },
                  {
                    label: t('triggers:fields.destination'),
                    name: 'place',
                    Input: PlaceSelect
                  },

                  {
                    label: t('triggers:fields.asset'),
                    name: 'asset',
                    Input: AssetSelect,
                    dynamicProps: item => ({ filter: { placeIds: item?.place?.id }, disabled: !item?.place?.id })
                  },

                  {
                    label: t('triggers:fields.responsible'),
                    name: 'user_or_group',
                    Input: UsersOrGroupsSelect,
                    width: 22
                  },
                  { label: t('triggers:fields.scheduling'), name: 'scheduling', Input: DateInput, useTime: true },
                  { label: t('triggers:fields.description'), name: 'description', Input: Textarea, width: 24 }
                ]}
              />
            </Separator>
          </Scroll>
          <Line />

          <Separator paddingH={2}>
            <SubmitBar onClick={validate} />
          </Separator>
        </Modal>
      </>
    </>
  )
}

export default ServiceOrdersSection
